import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaTicketAlt, FaSearch, FaUndo, FaTrash, FaPlus, FaEdit, FaEye, FaCheckCircle, FaTimesCircle, FaClock } from "react-icons/fa";
import $ from "jquery";

import Pagination from "Components/Pagination";
import CommonModal from "Components/CommonModal";
import { catchError, changeState, commonModalSetting } from "JS/common";
import { deleteCoupon, getCouponList } from "JS/API";
import CreateCouponModal from "Components/CreateCouponModal";
import CouponDetailModal from "Components/CouponDetailModal";
import { listPageStyles } from "utils/designSystem";

const Coupon = () => {
  const navigate = useNavigate();
  const [pageInfo, setPageInfo] = useState({
    page: 1,
    totalPage: 1,
    limit: 10,
  });
  const [searchData, setSearchData] = useState({
    coupon_name: "",
    coupon_type: "",
    coupon_status: "",
    use_start_date: "",
    use_end_date: "",
    expired_start_date: "",
    expired_end_date: "",
  });

  const [alert, setAlert] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  const [list, setList] = useState([]);
  let prevent = false;
  // 체크된 항목 ID들을 저장하는 상태
  const [idArr, setIdArr] = useState([]);

  const [isOpenCouponModal, setIsOpenCouponModal] = useState(false)
  const [isDetailModal, setIsDetailModal] = useState(false)

  const [selectedCoupon, setSelectedCoupon] = useState(null);

  // 스타일 정의
  const styles = {
    container: listPageStyles.container,
    header: listPageStyles.header,
    title: listPageStyles.title,
    searchCard: listPageStyles.searchCard,
    searchRow: {
      display: 'flex',
      gap: '20px',
      marginBottom: '16px',
      flexWrap: 'wrap'
    },
    searchField: {
      flex: 1,
      minWidth: '200px'
    },
    searchLabel: {
      display: 'block',
      fontSize: '14px',
      fontWeight: '600',
      color: '#374151',
      marginBottom: '6px'
    },
    searchInput: {
      width: '100%',
      padding: '8px 12px',
      border: '1px solid #cbd5e1',
      borderRadius: '6px',
      fontSize: '14px',
      color: '#1e293b'
    },
    searchSelect: {
      width: '100%',
      padding: '8px 12px',
      border: '1px solid #cbd5e1',
      borderRadius: '6px',
      fontSize: '14px',
      backgroundColor: '#ffffff',
      color: '#1e293b',
      cursor: 'pointer'
    },
    dateGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    buttonGroup: {
      display: 'flex',
      gap: '12px',
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    searchButton: listPageStyles.searchButton,
    resetButton: listPageStyles.resetButton,
    actionSection: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '16px'
    },
    deleteButton: listPageStyles.deleteButton,
    createButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      backgroundColor: '#059669',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    tableContainer: listPageStyles.tableContainer,
    tableWrapper: listPageStyles.tableWrapper,
    table: listPageStyles.table,
    th: listPageStyles.th,
    td: {
      padding: '12px',
      fontSize: '14px',
      color: '#1e293b',
      borderBottom: '1px solid #e2e8f0',
      transition: 'background-color 0.2s ease'
    },
    checkbox: listPageStyles.checkbox,
    checkboxLabel: listPageStyles.checkboxLabel,
    couponType: {
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      textAlign: 'center'
    },
    typePromotion: {
      backgroundColor: '#dbeafe',
      color: '#1d4ed8'
    },
    typeAdmin: {
      backgroundColor: '#dcfce7',
      color: '#16a34a'
    },
    discountValue: {
      fontWeight: '600',
      color: '#0f172a'
    },
    statusValid: {
      color: '#059669',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '4px'
    },
    statusExpired: {
      color: '#dc2626',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '4px'
    },
    statusEtc: {
      color: '#6b7280',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '4px'
    },
    actionButtons: {
      display: 'flex',
      gap: '8px'
    },
    editButton: {
      padding: '6px 12px',
      backgroundColor: '#3b82f6',
      color: '#ffffff',
      border: 'none',
      borderRadius: '4px',
      fontSize: '12px',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    detailButton: {
      padding: '6px 12px',
      backgroundColor: '#6b7280',
      color: '#ffffff',
      border: 'none',
      borderRadius: '4px',
      fontSize: '12px',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    issuanceType: {
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      backgroundColor: '#f1f5f9',
      color: '#1e293b',
      textAlign: 'center'
    }
  };

  // 쿠폰 유형별 스타일 반환
  const getCouponTypeStyle = (type) => {
    const baseStyle = styles.couponType;
    switch (type) {
      case 'promotion':
        return { ...baseStyle, ...styles.typePromotion };
      case 'admin':
        return { ...baseStyle, ...styles.typeAdmin };
      default:
        return { ...baseStyle, ...styles.typePromotion };
    }
  };

  // 쿠폰 유형 텍스트 반환
  const getCouponTypeText = (type) => {
    switch (type) {
      case 'promotion':
        return '프로모션';
      case 'admin':
        return '지급 쿠폰';
      default:
        return type;
    }
  };

  // 상태별 스타일과 아이콘 반환
  const getStatusStyle = (status) => {
    switch (status) {
      case '유효':
        return styles.statusValid;
      case '만료':
        return styles.statusExpired;
      default:
        return styles.statusEtc;
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case '유효':
        return <FaCheckCircle size={12} />;
      case '만료':
        return <FaTimesCircle size={12} />;
      default:
        return <FaClock size={12} />;
    }
  };

  const getList = async () => {
    if (prevent) return;
    prevent = true;
    setTimeout(() => (prevent = false), 200);
    setList([]);
    try {
      const result = await getCouponList({ ...pageInfo, ...searchData });

      if (typeof result === "object" && result?.data) {
        const responseData = result.data;
        setList(responseData.data || []);

        setPageInfo((prev) => ({
          ...prev,
          totalPage: responseData.meta?.total_page || 1,
        }));

      } else {
        console.error("API 응답 형식이 예상과 다릅니다:", result);
        await catchError(result, navigate, setAlertBox, setAlert);
      }
    } catch (error) {
      console.error("API 호출 중 오류 발생:", error);
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "데이터 로드 중 오류가 발생했습니다."
      );
    }
  };

  const handleSearch = () => {
    setPageInfo((prev) => ({
      ...prev,
      page: 1,
    }));

    const trimmedCouponName = searchData.coupon_name.trim();

    const searchParams = {
      ...searchData,
      coupon_name: trimmedCouponName,
      coupon_type: searchData.coupon_type,
      coupon_status: searchData.coupon_status,
      use_start_date: searchData.use_start_date,
      use_end_date: searchData.use_end_date,
      expired_start_date: searchData.expired_start_date,
      expired_end_date: searchData.expired_end_date,
    };

    setSearchData(searchParams);
    getList();
  };

  // 체크박스 개별 선택
  const checkEach = (e) => {
    e.stopPropagation();
    let all = $(".agencies-check").length;
    let checked = $(".agencies-check:checked").length;
    let arr = [];
    if (all !== checked) $(".agencies-all-check").prop("checked", false);
    else $(".agencies-all-check").prop("checked", true);
    for (let i = 0; i < all; i++) {
      if (document.getElementsByClassName("agencies-check")[i].checked) {
        const val = document.getElementsByClassName("agencies-check")[i].value;
        arr.push(val);
        setIdArr(arr);
      }
    }
  };

  // 전체 선택
  const checkAll = () => {
    let arr = [];
    if ($(".agencies-all-check").is(":checked")) {
      $(".agencies-check").prop("checked", true);
      const all = $(".agencies-check").length;
      for (let i = 0; i < all; i++) {
        const val = document.getElementsByClassName("agencies-check")[i].value;
        arr.push(val);
        setIdArr(arr);
      }
    } else {
      $(".agencies-check").prop("checked", false);
      setIdArr([]);
    }
  };

  const deleteCoupons = async () => {
    const targets = list
      .filter(item => idArr.includes(String(item.id)))
      .map(item => ({
        coupon_pk: item.id,
        coupon_code: item.coupon_code,
      }));

    try {
      const result = await deleteCoupon(targets);
      if (result?.status === 200) {
        setIdArr([]);
        $(".agencies-all-check").prop("checked", false);
        $(".agencies-check").prop("checked", false);

        commonModalSetting(setAlertBox, true, "alert", "정상적으로 삭제되었습니다.");
        setAlert("completeDelete");
      } else {
        await catchError(result, navigate, setAlertBox, setAlert);
      }
    } catch (err) {
      console.error(err);
      commonModalSetting(setAlertBox, true, "alert", "삭제 중 오류가 발생했습니다.");
    }
  };

  const renderList = () => {
    return list?.map(
      (
        {
          id,
          coupon_type,
          name,
          discount_value,
          period,
          all_issued_yn,
          created_at,
          status,
          coupon_code,
          description,
          start_date,
          end_date,
          discount_type,
          discount_val
        },
        idx
      ) => {
        return (
          <tr 
            key={id}
            onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#f8fafc'}
            onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
          >
            <td style={styles.td} onClick={(e) => e.stopPropagation()}>
              <label style={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  className="agencies-check"
                  onChange={checkEach}
                  value={id}
                  style={styles.checkbox}
                />
              </label>
            </td>

            <td style={styles.td}>
              <span style={getCouponTypeStyle(coupon_type)}>
                {getCouponTypeText(coupon_type)}
              </span>
            </td>

            <td style={styles.td}>
              <div style={{ fontWeight: '500' }}>{name}</div>
            </td>

            <td style={styles.td}>
              <span style={styles.discountValue}>{discount_value}</span>
            </td>

            <td style={styles.td}>
              <div>
                <div style={{ marginBottom: '2px' }}>{period}</div>
                <span style={getStatusStyle(status)}>
                  {getStatusIcon(status)}
                  {status}
                </span>
              </div>
            </td>

            <td style={styles.td}>{created_at}</td>

            <td style={styles.td}>
              <span style={styles.issuanceType}>
                {(() => {
                  if (all_issued_yn === "ALL") return "전체 발급";
                  if (all_issued_yn === "PORTION") return "선택 발급";
                  if (all_issued_yn?.includes("ALL") && all_issued_yn?.includes("PORTION"))
                    return "전체 + 선택 발급";
                  return "-";
                })()}
              </span>
            </td>

            <td style={styles.td}>
              <div style={styles.actionButtons}>
                <button
                  style={styles.editButton}
                  onClick={() => {
                    setSelectedCoupon({
                      id,
                      coupon_type,
                      name,
                      coupon_code,
                      description,
                      discount_val,
                      discount_type,
                      start_date,
                      end_date,
                    });
                    setIsOpenCouponModal(true);
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
                >
                  <FaEdit size={10} />
                  수정
                </button>

                <button
                  style={styles.detailButton}
                  onClick={() => {
                    setSelectedCoupon({ id, coupon_code });
                    setIsDetailModal(true);
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
                >
                  <FaEye size={10} />
                  자세히
                </button>
              </div>
            </td>
          </tr>
        );
      },
      []
    );
  };

  useEffect(() => {
    getList();
  }, [pageInfo.page, searchData.sort]);

  useEffect(() => {
    document.title = "마크픽 관리자 > 쿠폰 관리";
  }, []);

  return (
    <div style={styles.container}>
      {/* 헤더 */}
      <div style={styles.header}>
        <h1 style={styles.title}>
          <FaTicketAlt />
          COUPON-LIST
        </h1>
      </div>

      {/* 검색 영역 */}
      <div style={styles.searchCard}>
        {/* 첫 번째 행 */}
        <div style={styles.searchRow}>
          <div style={styles.searchField}>
            <label style={styles.searchLabel}>쿠폰명</label>
            <input
              type="text"
              placeholder="쿠폰명을 입력해주세요."
              value={searchData.coupon_name}
              onChange={(e) =>
                changeState(setSearchData, "coupon_name", e.target.value)
              }
              style={styles.searchInput}
            />
          </div>
          <div style={styles.searchField}>
            <label style={styles.searchLabel}>쿠폰유형</label>
            <select
              value={searchData.coupon_type}
              onChange={(e) =>
                changeState(setSearchData, "coupon_type", e.target.value)
              }
              style={styles.searchSelect}
            >
              <option value="">선택</option>
              <option value="promotion">프로모션</option>
              <option value="admin">지급 쿠폰</option>
            </select>
          </div>
          <div style={styles.searchField}>
            <label style={styles.searchLabel}>쿠폰 상태</label>
            <select
              value={searchData.coupon_status}
              onChange={(e) =>
                changeState(setSearchData, "coupon_status", e.target.value)
              }
              style={styles.searchSelect}
            >
              <option value="all">선택</option>
              <option value="valid">유효</option>
              <option value="expired">만료</option>
              <option value="etc">기타</option>
            </select>
          </div>
        </div>

        {/* 두 번째 행 - 날짜 선택 */}
        <div style={styles.searchRow}>
          <div style={styles.searchField}>
            <label style={styles.searchLabel}>시작일</label>
            <div style={styles.dateGroup}>
              <input
                type="date"
                value={searchData.use_start_date}
                onChange={(e) =>
                  changeState(setSearchData, "use_start_date", e.target.value)
                }
                style={styles.searchInput}
              />
              <span style={{ color: '#6b7280' }}>~</span>
              <input
                type="date"
                value={searchData.use_end_date}
                onChange={(e) =>
                  changeState(setSearchData, "use_end_date", e.target.value)
                }
                style={styles.searchInput}
              />
            </div>
          </div>
          <div style={styles.searchField}>
            <label style={styles.searchLabel}>만료일</label>
            <div style={styles.dateGroup}>
              <input
                type="date"
                value={searchData.expired_start_date}
                onChange={(e) =>
                  changeState(setSearchData, "expired_start_date", e.target.value)
                }
                style={styles.searchInput}
              />
              <span style={{ color: '#6b7280' }}>~</span>
              <input
                type="date"
                value={searchData.expired_end_date}
                onChange={(e) =>
                  changeState(setSearchData, "expired_end_date", e.target.value)
                }
                style={styles.searchInput}
              />
            </div>
          </div>
        </div>

        {/* 세 번째 행 - 버튼 */}
        <div style={{...styles.searchRow, marginBottom: 0, justifyContent: 'flex-end'}}>
          <div style={styles.buttonGroup}>
            <button
              style={styles.searchButton}
              onClick={handleSearch}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
            >
              <FaSearch />
              검색
            </button>
            <button
              style={styles.resetButton}
              onClick={() => {
                setSearchData({
                  coupon_name: "",
                  coupon_type: "",
                  coupon_status: "",
                  use_start_date: "",
                  use_end_date: "",
                  expired_start_date: "",
                  expired_end_date: "",
                });
                setPageInfo((prev) => ({
                  ...prev,
                  page: 1,
                }));
                getList();
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
            >
              <FaUndo />
              초기화
            </button>
          </div>
        </div>
      </div>

      {/* 액션 버튼들 */}
      <div style={styles.actionSection}>
        <button
          style={styles.deleteButton}
          onClick={() => {
            if (!idArr.length)
              return commonModalSetting(
                setAlertBox,
                true,
                "alert",
                "삭제할 건을 선택해 주세요."
              );
            else {
              setAlert("deleteConfirm");
              commonModalSetting(
                setAlertBox,
                true,
                "confirm",
                "삭제하면 다시 복구할 수 없습니다.<br/>정말 삭제하시겠습니까?"
              );
            }
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
        >
          <FaTrash />
          삭제하기
        </button>

        <button
          style={styles.createButton}
          onClick={() => {
            setSelectedCoupon(null);
            setIsOpenCouponModal(true)
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#047857'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#059669'}
        >
          <FaPlus />
          신규생성
        </button>
      </div>

      {/* 테이블 */}
      <div style={styles.tableContainer}>
        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>
                  <label style={styles.checkboxLabel}>
                    <input
                      type="checkbox"
                      className="agencies-all-check"
                      onChange={checkAll}
                      style={styles.checkbox}
                    />
                  </label>
                </th>
                <th style={styles.th}>쿠폰 유형</th>
                <th style={styles.th}>쿠폰명</th>
                <th style={styles.th}>할인 금액</th>
                <th style={styles.th}>쿠폰 기간</th>
                <th style={styles.th}>등록일</th>
                <th style={styles.th}>전체 발급 여부</th>
                <th style={styles.th}>비고</th>
              </tr>
            </thead>

            <tbody>
              {list?.length > 0 ? (
                renderList()
              ) : (
                <tr>
                  <td colSpan="8" style={{...styles.td, textAlign: 'center', padding: '48px', color: '#6b7280'}}>
                    데이터가 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Pagination pageInfo={pageInfo} setPageInfo={setPageInfo} />

      {/* 모달들 */}
      {isOpenCouponModal && (
        <CreateCouponModal
          setIsOpenCouponModal={setIsOpenCouponModal}
          getList={getList}
          editCouponData={selectedCoupon}
        />
      )}

      {isDetailModal && (
        <CouponDetailModal 
          setIsDetailModal={setIsDetailModal}
          getList={getList}
          detailData={selectedCoupon} 
        />
      )}

      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "deleteConfirm") deleteCoupons();
            else if (alert === "completeDelete") getList();
            else if (alert === "logout") navigate("/");
            else return;
          }}
        />
      )}

      {/* 반응형 스타일 */}
      <style>{`
        @media (max-width: 768px) {
          .table-wrapper {
            -webkit-overflow-scrolling: touch;
          }
          
          .table-wrapper::-webkit-scrollbar {
            height: 8px;
          }
          
          .table-wrapper::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 4px;
          }
          
          .table-wrapper::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 4px;
          }
          
          .table-wrapper::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
        }
      `}</style>
    </div>
  );
};

export default Coupon;